<div id="installer_buttons">
  @if (betaOnly) {
    <h5 class="brandfont-bold">Installers</h5>
  }
  <div class="installer_btn_holder" [class.justify-content-center]="centered" [class.d-flex]="!isSideBar" [class.flex-wrap]="!isSideBar">
    @for (group of installerGroups; track group.type) {
      @for (dl of group.latest.platforms; track dl.url) {
        @if (dl.osGroup == "other" || showAllSystems || dl.osGroup == myOs) {
          <div class="m-b-10" [class.installer-btn-pill]="!isSideBar">
            <span>
              @if (group.isOwnProduct) {
                @if (dl.osGroup == "other") {
                  <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">Installer</h6>
                } @else {
                  <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ "product_detail.installer_for" | translate: { os: dl.osLabel } }}</h6>
                }
                <button class="btn btn-primary btn-sm" (click)="downloadTokenizedAsset(dl)">
                  @if (product.contractId != "subscriptiontrial") {
                    @if (dl.osIcon == "apple") {
                      <i class="fa fa-apple"></i>
                    }
                    @if (dl.osIcon == "windows") {
                      <i class="fa fa-windows"></i>
                    }
                    @if (dl.osIcon == "linux") {
                      <i class="fa fa-linux"></i>
                    }
                    @if (!dl.osIcon) {
                      <fa-icon icon="download"></fa-icon>
                    }
                  }
                  {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
                </button>
              }
              @if (!group.isOwnProduct) {
                @if (dl.osGroup == "other") {
                  <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ group.type }}</h6>
                } @else {
                  <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ group.type }} for {{ dl.osLabel }}</h6>
                }
                <button class="btn btn-primary btn-sm" (click)="downloadTokenizedAsset(dl)">
                  @if (dl.osIcon == "apple") {
                    <i class="fa fa-apple"></i>
                  }
                  @if (dl.osIcon == "windows") {
                    <i class="fa fa-windows"></i>
                  }
                  @if (dl.osIcon == "linux") {
                    <i class="fa fa-linux"></i>
                  }
                  {{ "download.download" | translate }}
                </button>
              }
              @if (dl.osGroup == "other") {
                <small class="text-muted d-block m-t-10">{{ dl.title }}</small>
              }
            </span>
            <div>
              <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
              @if (dl.releaseDate) {
                <br />
                <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
              }
            </div>
          </div>
        }
      }
    }
  </div>

  @if (product.partnerName && product.partnerName == "pace") {
    <div>
      {{ "products.requires_ilok" | translate }} -
      <span class="btn btn-sm btn-primary" (click)="showiLokOverlay()">{{ "general.learn_more" | translate }}</span>
    </div>
  }

  @if (product.partnerDownloadUrl && product.partnerName != "pace" && product.stringId != "eastwest.composercloud") {
    <div class="installer_btn_holder" [class.justify-content-center]="centered">
      <a (click)="onPartnerDownloadClick()">
        @if (product.contractId == "subscriptiontrial") {
          <button class="btn btn-primary btn-sm">
            {{ "product_detail.start_trial" | translate }}
          </button>
        }
        @if (product.contractId != "subscriptiontrial" && !product.partnerDownloadUrl) {
          <button class="btn btn-primary btn-sm">
            <fa-icon icon="download"></fa-icon>
            {{ "product_detail.download_installer" | translate }}
          </button>
        }
        @if (product.partnerDownloadUrl) {
          <button class="btn btn-primary btn-sm">
            {{ (product.stringId == "splicebundle" ? "product_detail.start_trial" : "general.redeem") | translate }}
          </button>
        }
      </a>
    </div>
  }
  @if (hasNoInstallers && betaOnly) {
    <div class="text-muted m-b-30">No beta installers are available for this product.</div>
  }
</div>

@if (firmwareLatest || betaFirmwareList.length || (betaOnly && product.categoryId == "hardware")) {
  <div class="m-b-10">
    @if (betaOnly) {
      <h5 class="brandfont-bold">Firmware</h5>
    }
    @if (!betaOnly) {
      @if (firmwareLatest) {
        <div class="installer_btn_holder" [class.justify-content-center]="centered">
          <a (click)="showFirmwareInstructions(firmwareLatest)">
            <button class="btn btn-primary btn-sm" [disabled]="checkingFirmwareInstructions">
              @if (checkingFirmwareInstructions) {
                <fa-icon icon="spinner" animation="spin"></fa-icon>
              } @else {
                <fa-icon icon="download"></fa-icon>
              }
              {{ "product_detail.get_latest_firmware" | translate }}
            </button>
          </a>
          <br />
          <span [class]="firmwareLatest.beta ? 't-12 c-green' : 't-12'">{{ (firmwareLatest.beta ? "BETA " : "") + "Version " + firmwareLatest.version }}</span>
        </div>
      }
    }
    @if (betaOnly && betaFirmwareList.length) {
      @for (fw of betaFirmwareList; track fw.url) {
        <div class="installer_btn_holder m-b-10" [class.justify-content-center]="centered">
          <a (click)="showFirmwareInstructions(fw)">
            <button class="btn btn-primary btn-sm" [disabled]="checkingFirmwareInstructions">
              @if (checkingFirmwareInstructions) {
                <fa-icon icon="spinner" animation="spin"></fa-icon>
              } @else {
                <fa-icon icon="download"></fa-icon>
              }
              Firmware
            </button>
          </a>
          <br />
          <span class="t-12 bold">Beta Version {{ fw.version }}</span>
          <br />
          <span class="t-12">{{ fw.filename }}</span>
        </div>
      }
    }
    @if (!betaFirmwareList.length && betaOnly) {
      <div class="text-muted m-b-30">No beta firmware is available for this product.</div>
    }
  </div>
}

@if (!betaOnly || !hasNoInstallers) {
  <div class="installer_btn_actions m-t-20" [class.text-center]="centered">
    @if (hasMacInstaller && hasWinInstaller) {
      <button [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'" (click)="showAllSystems = !showAllSystems">
        <span>{{ (showAllSystems ? "product_detail.show_my_system" : "product_detail.show_all_systems") | translate }}</span>
        &nbsp;
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
    @for (group of installerGroups; track group.type) {
      @if (group.hasHistory) {
        <button [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'" (click)="showVersionsModal(group)">
          <span>More {{ group.type }} versions</span>
          &nbsp;
          <fa-icon icon="chevron-right"></fa-icon>
        </button>
      }
    }
    @if (releaseNotesItem) {
      <button [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'" (keyup.enter)="downloadTokenizedAsset(releaseNotesItem)" (click)="downloadTokenizedAsset(releaseNotesItem)">
        <span>{{ "product_detail.download_release_notes" | translate }}</span>
        &nbsp;
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
    @if (showManageActivations) {
      <button [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'" [routerLink]="['/account/plan']">
        <span>{{ "product_detail.activations.manage_title" | translate }}</span>
        &nbsp;
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
  </div>
}
